import { gql } from "@apollo/client";

export const ResetEmpPassword = gql`
  mutation ResetEmpPassword(
    $token: String!
    $empID: ID!
    $customerID: ID!
    $user_details: SubscribedUser!
    $password: String!
  ) {
    ResetEmpPassword(
      token: $token
      empID: $empID
      customerID: $customerID
      user_details: $user_details
      password: $password
    )
  }
`;
